const styles = (theme) => ({
    paper: {
        background: 'transparent',
    },
});

export default styles;
